import { Overlay } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSpinner } from "@angular/material/progress-spinner";
import { ResultComponent } from "app/main/result/result.component";

@Injectable({
  providedIn: "root",
})
export class UiService {
  private spinnerTopRef = this.cdkSpinnerCreate();

  constructor(private overlay: Overlay, private matDialog: MatDialog) {}

  private cdkSpinnerCreate() {
    return this.overlay.create({
      hasBackdrop: true,
      backdropClass: "dark-backdrop",
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });
  }

  public showLoading() {
    this.hideLoading();
    this.spinnerTopRef.attach(new ComponentPortal(MatSpinner));
  }

  public hideLoading() {
    this.spinnerTopRef.detach();
  }

  public showSuccessDialog(msg) {
    this.matDialog.closeAll();
    this.matDialog.open(ResultComponent, {
      data: {
        status: "success",
        msg: msg,
      },
    });
  }

  public showErrorDialog(msg) {
    this.matDialog.closeAll();
    this.matDialog.open(ResultComponent, {
      data: {
        status: "failed",
        msg: msg,
      },
    });
  }
}
